export enum DimensionSource {
  Frame = 'Frame',
  ProportionalSize = 'ProportionalSize',
  Size = 'Size',
}
